import { procurementAPI } from "../../axios";

export const actions = {

    //Procurable
    GetProcurables(context, data){
        return procurementAPI.get(`Procurable/All/${data.campusId}/${data.cycle}/${data.mixStatus}`);
    },
    GetProcurableSummary(context, data){
        return procurementAPI.get(`Procurable/All/Summary/${data.campusId}/${data.cycle}/${data.mixStatus}`);
    },
    GetDUApi(context, data){
        return procurementAPI.get(`Procurable/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetApiResources(context, data){
        return procurementAPI.get(`Procurable/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetAllowedProcurables(context, data){
        return procurementAPI.get(`Procurable/Allowed/${data.campusId}/${data.cycle}`);
    },
    GetAllowedProcurableSummary(context, data){
        return procurementAPI.get(`Procurable/Allowed/Summary/${data.campusId}/${data.cycle}`);
    },
    GetAllowedDUApi(context, data){
        return procurementAPI.get(`Procurable/Allowed/Summary/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetAllowedApiResources(context, data){
        return procurementAPI.get(`Procurable/Allowed/Summary/Api/${data}`);
    },
    GetProcurableApiResources(context, data){
        return procurementAPI.get(`Procurable/ApiResources/${data}`);
    },
    GetProcurableRows(context, data){
        return procurementAPI.get(`Procurable/All/Total/${data.campusId}/${data.cycle}`);
    },
    GetAvailableFSProcurables(context, data){
        return procurementAPI.get(`Procurable/Available/${data.campusId}/${data.cycle}/${data.fcId}`);
    },
    AllowPR(context, data){
        return procurementAPI.put(`Procurable/AllowPr/${data.id}?allowPr=${data.pr}`);
    },
}